<template>
  <v-container fluid class="mx-0 px-0" @keydown.enter="submit()">
    <template v-if="showError">
      <v-row>
        <v-col cols="12">
          <v-alert dense outlined type="error" class="my-0">
            <span v-html="errorMessage"></span>
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="9" v-if="showPaieska">
        <el-text-field
          label="Notarinio įgaliojimo numeris"
          tooltip="Modalas asmuo. Notarinio įgaliojimo numeris"
          autofocus
          v-model="notarinio_registro_nr"
          @focus="focusRegistroNr"
          @blur="blurRegistroNr"
        />
      </v-col>
      <v-col cols="3" class="text-right" v-if="showPaieska">
        <el-button
          class="mt-4"
          primary
          @click.native="checkIgaliojimasRegistras()"
          :loading="loading"
          :disabled="disabledIeskoti"
          small
        >
          Tikrinti registre
        </el-button>
      </v-col>
      <v-col cols="12">
        <el-textarea
          label="Veikiantis pagal"
          v-model="igaliojimas"
          :readonly="igaliojimasReadonly"
          :rows="igaliojimasRows"
          :auto-grow="autoGrow"
          counter="1000"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
export default {
  name: 'ElVeikiantisPagal',
  mixins: [userRole],
  props: {
    value: String,
    readonly: Boolean,
    foreign: Boolean,
    ntrpaslaugos: { type: Boolean, default: false },
    asmKodas: String,
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      notarinio_registro_nr: null,
      loadingRegistras: false,
      showError: false,
      errorMessage: null,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'appSavitarna']),
    igaliojimas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showPaieska() {
      return (
        !this.ntrpaslaugos &&
        !this.readonly &&
        !this.foreign &&
        this.roleOr(['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'])
      )
    },
    disabledIeskoti() {
      return !this.notarinio_registro_nr
    },
    autoGrow() {
      return this.readonly
    },
    igaliojimasReadonly() {
      return this.readonly
    },
    igaliojimasRows() {
      return this.igaliojimasReadonly ? 0 : 3
    },
  },
  created() {
    //
  },
  methods: {
    resetError() {
      this.errorMessage = null
      this.showError = false
    },
    checkIgaliojimasRegistras() {
      this.loading = true
      this.resetError()

      const data = {
        obj_id: this.objektasID,
        asm_kodas: this.asmKodas,
        notarinio_registro_nr: this.notarinio_registro_nr,
      }

      this.$axios
        .post(`asmens-igaliojimas/search`, data)
        .then(res => {
          this.igaliojimas = res.data.igaliojimas
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.errorMessage = err.response.data.message
            this.showError = true
            return
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteIgaliojimas() {
      this.igaliojimas = null
    },
    submit() {
      if (!this.loading && !this.disabledIeskoti) {
        this.checkIgaliojimasRegistras()
      }
    },
    focusRegistroNr() {
      this.$emit('disableSave', true)
    },
    blurRegistroNr() {
      this.$emit('disableSave', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.igaliojimas-div {
  max-height: 100px;
}
</style>
